import { Box, Stack } from "@mui/material";
import { DamsAppAsset } from "../../assets/registry";
import { MainPageBase } from "../page-bases/MainPageBase";
import { useEffect, useState } from "react";
import DamsTable from "../../components/Table/CollapsibleTable";
import { NoItemContent } from "../page-bases/NoItemContent";
import { TRowItem } from "../../components/Table/TableRow";
import { ModalBase } from "../../components/Modals/ModalBase";
import ModalItemInput from "../../components/Input/ModalItemInput";
import { IPagination, IQueryPerams, IUserCategory, PageActions } from "../../config/types";
import { usePageModels } from "../../hooks/usePageActions";

import ActionModal from "../../components/Modals/ActionModal";
import { useDmsForm } from "../../hooks/useDmsFrom";
import { userCategoryApi } from "../../services/users/userCategory";
import { usePagination } from "../../hooks/usePagination";
import { BulkDeleteController } from "../../common-ui/BulkDeleteController";
import { useMangeTableItems } from "../../hooks/useManageTableItems";
import { UserCategoryFilter } from "../../common-ui/page-filters/UserCategoryFilter";
import { formatDate } from "../../utils/common";

function UserCategoriesMainPage() {
  const [pageState, setPageState] = useState("main");
  const [dataset, setDataset] = useState<TRowItem[]>([]);
  const [pageAction, updatePageAction] = useState<PageActions>();
  const { models, closeModel, openModel } = usePageModels();
  const [isProcessing, setProcess] = useState(false);
  const [querySet, setQuerySet] = useState<IQueryPerams>({ is_deleted: false });

  const {
    form,
    updateForm,
    updateInputField,
    fieldHasError,
    setSubmitAttempt,
    resetForm,
    isFormValid,
    getFormValues,
  } = useDmsForm<{name:string}>({name:''})


  const {
    pagination,
    paginateToNextPage,
    paginateToPreviousPage,
    paginateToPageNumber,
    updatePaginationInitState
  } = usePagination<any>(userCategoryApi.getUserCategories);

  const {
    selectedRowItems,
    toggleRow,
    toggleSelectAllRow,
    resetSelectedRowItems
  } = useMangeTableItems(dataset);

  const tkeys = ["name", "created_at","updated_at"];

  const columns = ["User Category Name", "Date Added","Last updated"];

     const populateDataSet=( data: IUserCategory[],pagination?:IPagination)=>{
        const formatData = (data).map((data) => ({
          ...data,
          created_at:formatDate( data.created_at),
          updated_at:data.updated_at? formatDate( data.updated_at):'Not Yet'
        })); 
        setDataset(formatData);
        updatePaginationInitState(pagination);
      }
    
  const fetchData = async () => {
      const result = await userCategoryApi.getUserCategories({is_deleted:false});
      if (result?.data) {
        populateDataSet(result.data,result.pagination);
        updatePaginationInitState();
      }
  };
  

  useEffect(() => {

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const page_info = getEmptyPageInfo(pageState);





  async function handleAddRequest() {
   setSubmitAttempt(true)
    if (isFormValid()) {
      setProcess(true);
      const request =
        pageAction?.type === "add"
          ? userCategoryApi.createUserCategory(getFormValues())
          : userCategoryApi.updateUserCategory(pageAction?.id ?? "", {
              name: form.name.value,
            });
      const res = await request;
      if (res.success) {
        fetchData();
      }
      setProcess(false);
      updatePageAction({
        type: pageAction?.type,
        message: res.message,
        title: pageAction?.type === "edit" ? "Update User category" : "New User category",
        success: res.success,
      });
      openModel("alert");
      resetForm();
    }
  }
  function addNewItem() {
    resetForm();
    openModel("add");
    updatePageAction({
      type: "add",
    });
  }

  function openDeleteModel(item: TRowItem) {
    openModel("delete");
    updatePageAction({
        id: item.id,
        name: item.name,
      
    });
  }
  function updateField(item: TRowItem) {
    updateForm({
      name: {
        value: item.name,
        isValid: true,
      },
    });
    openModel("add");
    updatePageAction({
      id: item.id,
      name: item.name,
      type: "edit",
    });
  }
  async function handleDeleteRequest() {
    setProcess(true);
    const res = await userCategoryApi.deleteUserCategory(pageAction?.id ?? "");
    if (res.success) {
      fetchData();
    }
    setProcess(false);
    updatePageAction({
        title: res.success ? "Delete User category" : "Delete User category Failed",
        message: res.message,
        success: res.success,
      
    });
    openModel("alert");
  }

  function toggleAlertModal() {
    if (pageAction?.type === "add") {
      openModel("add");
    } else {
      closeModel();
    }
  }

  function clearSearch() {
    setPageState("empty-db");
  }

    const renderHeaderDropDownMenu = ({
      closeDialog}: {closeDialog: () => void;}) => {
      const batchDeleteCallback = async () => {
        resetSelectedRowItems();
        await fetchData();
        closeDialog();
      };
      return (
        <Stack direction={"column"} alignItems={"flex-start"} spacing={1}>
          <BulkDeleteController
            selectedRowItems={selectedRowItems}
            reset={batchDeleteCallback}
            ftn={userCategoryApi.deleteUserCategory}
            idKey={"id"}
          />
        </Stack>
      );
    };
  return (
    <MainPageBase
      title={"User category"}
      subtitle={""}
      pageState={pageState}
      addItemBtnOnClick={() => addNewItem()}
      addItemBtnText="Add User category"
    >
      <Box
        height={`100%`}
        display={"flex"}
        alignItems={pageState !== "main" ? "center" : ""}
        justifyContent={"center"}

      // border={'2px solid blue'}
      >
        {pageState !== "main" ? (
          <NoItemContent
            type={pageState}
            title={page_info.title}
            subtitle={page_info.message}
            addItemBtn={() => addNewItem()}
            clearSearchBtn={() => clearSearch()}
          />
        ) : (
          <Stack width={"100%"} spacing={1}>
          <UserCategoryFilter<IUserCategory[]>
           ftn={userCategoryApi.getUserCategories}
           updateDataSet={populateDataSet}
           updateQuerySet={setQuerySet} />
            <DamsTable
              tableTitle="User category"
              tableSubtitle=""
              numTableRecords="25"
              tableHeaders={columns}
              tableKeys={tkeys}
              data={dataset}
              onTableItemEdit={updateField}
              onTableItemDelete={openDeleteModel}
              hasPagination
              paginationState={pagination}
              onNextPage={paginateToNextPage(querySet,populateDataSet)}
              onPreviousPage={paginateToPreviousPage(querySet,populateDataSet)}
              setActivePage={paginateToPageNumber(populateDataSet,querySet)}
              useTableCheckbox
              onTableItemSelect={toggleRow}
              toggleSelectAllRow={toggleSelectAllRow}
              selectedRowItems={selectedRowItems}
              headerDropDownMenu={renderHeaderDropDownMenu}
              tableTitleBadge={selectedRowItems.length===0?undefined:selectedRowItems.length + ' selected' }
            />

            {/* Add  Modal */}
            <ModalBase
              open={models.showAddModel}
              title={
                  pageAction?.type === "add" ? "Add New User category" : "Edit User category"
              }
              subtitle={""}
              type={"add-item"}
              showHeader={true}
              leftIcon={DamsAppAsset.icons.Programmes}
              leftBtnTxt="Cancel"
              onLeftBtnPress={closeModel}
              rightBtnTxt={
                pageAction?.type === "add" ? "Add User category" : "Edit User category"
              }
              onRightBtnPress={handleAddRequest}
              onRightBtnLoading={isProcessing}
              onClose={closeModel}
            >
              <Stack gap={2}>
                <ModalItemInput
                  label="User category"
                  placeholder="Enter User category Name"
                  handleChange={updateInputField("name")}
                  value={form.name.value}
                  error={fieldHasError('name')}
                  errorMessage={form.name.errorMessage}
                />
              </Stack>


            </ModalBase>

            <ModalBase
              open={models.showDeleteModel}
              title={"Delete User category"}
              subtitle={
                <Box>
                  Once you delete{" "}
                  <span style={{ fontWeight: "bold" }}>
                    {pageAction?.name}
                  </span>
                  , all related information will be lost forever. Are you sure
                  you want to proceed?
                </Box>
              }
              type={"action"}
              showHeader={true}
              leftIcon={DamsAppAsset.icons.delete_icon}
              leftBtnTxt="Cancel"
              onLeftBtnPress={closeModel}
              rightBtnTxt="Delete"
              onRightBtnPress={handleDeleteRequest}
              onRightBtnLoading={isProcessing}
              onClose={closeModel}
            />

            <ActionModal
              show={models.showAlertModel}
              title={pageAction?.title ?? ""}
              leftIcon={
                pageAction?.success === false
                  ? DamsAppAsset.icons.warning
                  : undefined
              }
              subtitle={pageAction?.message ?? ""}
              onLeftBtnPress={closeModel}
              leftBtnTxt={"close"}
              onRightBtnPress={toggleAlertModal}
              rightBtnTxt={pageAction?.type === "add" ? "Add New" : "continue"}
              onClosePress={closeModel}
            />
          </Stack>
        )}
      </Box>
    </MainPageBase>
  );
}
const getEmptyPageInfo = (key: string): { title: string; message: string } => {
  if (page_msg.hasOwnProperty(key)) {
    return page_msg[key];
  } else {
    return { title: "", message: "" };
  }
};

const page_msg: { [key: string]: { title: string; message: string } } = {
  "empty-db": {
    title: "No User category Found",
    message:
      'No User category have been added yet. Click the "Add New" button to add a new Programme.',
  },

  "empty-search": {
    title: "No User category Found",
    message:
      "No User category found in your database. Please add a new Programme to find them in the User category tab ",
  },
};

export default UserCategoriesMainPage;